import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import PreviousYearQuestionTable from './PreviousYearQuestionTable';

const PreviousYearQuestion = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Previous Year Question' parent='Previous Year Question' />
      <Container fluid={true}>
        <Row>
          <PreviousYearQuestionTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default PreviousYearQuestion;
